import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, CardBody, Card, CardHeader, Row } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import AddEditPersonModal from './Add_Edit/AddEditPerson';
import DeletePersonModal from './Delete/DeletePerson';
import { getPersonList, getPersonQuery } from '../../../slices/person/thunk';
import ImportPersonModal from './Add_Edit/ImportPerson';
import {Tooltip} from '@mantine/core';
const plantillaFilename = 'SPED - Plantilla de Carga de Personas v2.xlsx';
const plantillaExcel = require('../../../assets/documentTemplates/' + plantillaFilename);


const PersonList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorPerson = createSelector(
		state => state.Persons,
		data => ({
			personList: data.personList,
			isLoadingList: data.isLoadingList,
			isPersonSuccess: data.isPersonSuccess,
			isLoadingPersonList: data.isLoadingPersonList,
		})
	);

	const { personList, isLoadingList, isLoadingPersonList } = useSelector(selectorPerson);


	useEffect(() => {
		dispatch(getPersonQuery());
	}, []);


	const [dataPerson, setDataPerson] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Person
	const [modal, setModal] = useState(false);
	const [modalImport, setModalImport] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
	}


	function handleToggleModalImport() {
		setModalImport(!modalImport);
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = person => {
		setDataPerson(person);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = person => {
		setDataPerson(person);
		handleToggleModal();
	};

	function synchronize() {
		dispatch(synchronizePerson());
	}

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'person',
				columnDefType: 'display',
				size: 'auto',
				Cell: ({ row }) => (
					<div className='d-flex'>
						<div className='flex-shrink-0'>
							<ul className='list-inline mb-0'>
								<li className='list-inline-item'>
									<Link
										to='#'
										onClick={() => {
											const personData = row.original;
											setIsEdit(true);
											handleClickEdit(personData);
										}}
									>
										<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
									</Link>
								</li>
								{/* <li className='list-inline-item'>
									<Link
										to='#'
										className='remove-item-btn'
										onClick={() => {
											const personData = row.original;
											handleClickDelete(personData);
										}}
									>
										<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
									</Link>
								</li> */}
							</ul>
						</div>
					</div>
				),
			},
			{
				header: 'Activo', accessorKey: 'active',
				width: 'auto',
				accessorFn: row => {
					let active = row?.active; 
					return active ? 'Activo' : 'Inactivo'
				},
				dataType: 'multi-select',
				Cell: ({ row }) => {
					return (
						(

							<div>
								<span className={`badge ${row?.original?.active ? 'span-success-color-theme' : 'span-danger-color-theme'}`}>
									{row?.original?.active
										? 'Activo'
										: 'Inactivo'}
								</span>
							</div>
						)
					);
				},
			},
			{ header: 'Rut', accessorKey: 'rut', width: 'auto', },
			{
				header: 'Nombres',
				width: 'auto',
				accessorKey: 'full_name',
				Cell: ({ row }) => {
					const { first_name, second_name } = row.original || {}; // Evita errores si `person` es undefined
					return [first_name, second_name].filter(Boolean).join(' ')|| '-';
				},
			},
			{
				header: 'Apellidos',
				width: 'auto',
				accessorKey: 'full_surname',
				Cell: ({ row }) => {
					const { first_surname, second_surname } = row.original || {};
					return [first_surname, second_surname].filter(Boolean).join(' ')|| '-';
				},
			},
			{ header: 'Departamento', accessorKey: 'management.name', dataType: 'multi-select', width: 'auto', },
			{ header: 'Cargo', accessorKey: 'management_position.name', dataType: 'multi-select', width: 'auto', },	

			{ header: 'Empresa', accessorKey: 'company.name', dataType: 'multi-select', width: 'auto', },
			{ header: 'Nombre Centro Costo', accessorKey: 'cost_center.name', dataType: 'multi-select', width: 'auto', },
			{ header: 'Código Centro Costo', accessorKey: 'cost_center.code', dataType: 'multi-select', width: 'auto', },
			{ header: 'Correo', accessorKey: 'mail', width: 'auto', },
			{ header: 'Celular', accessorKey: 'phone', width: 'auto', },
		],
		[handleClickEdit, handleClickDelete]
	);


	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<a href={plantillaExcel} download={plantillaFilename}>
											<button className='btn btn-label btn-primary'>
												<i className='icon-file-x label-icon'></i>{' '}
												Descargar Plantilla
											</button>
										</a>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												handleToggleModalImport();
											}}
										>
											<i className='icon-download label-icon'></i>{' '}
											Importar Personas
										</button>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataPerson(null);
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Persona
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								getDataFunc={getPersonQuery}
								queryPopulate={[
									'company',
									'cost_center',
									'management',
									'management_position',
								]}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								customToolbarActions={({ table }) => (
									<div className="d-flex justify-content-start gap-2">
										<Tooltip label='Crear Persona' position='top' withinPortal>
											<button
												className='btn d-flex align-items-center btn-tooltip-hover gap-1'
												onClick={() => {
													setIsEdit(false);
													setDataPerson(null);
													handleToggleModal();
												}}
											>
												<i className='icon-plus icon-tooltop-size'></i>
												<span>Crear</span>
											</button>
										</Tooltip>
										<Tooltip label='Descargar Plantilla' position='top' withinPortal>
											<a href={plantillaExcel} download={plantillaFilename}>
												<button className='btn d-flex align-items-center btn-tooltip-hover gap-1'>
													<i className='icon-download icon-tooltop-size'></i>
													<span>Descargar</span>
												</button>
											</a>
										</Tooltip>
										<Tooltip label='Importar Personas' position='top' withinPortal>
											<button
												className='btn d-flex align-items-center btn-tooltip-hover gap-1'
												onClick={() => handleToggleModalImport()}
											>
												<i className='icon-file-x icon-tooltop-size'></i>
												<span>Importar</span>
											</button>
										</Tooltip>
										
									</div>
								)}
								nameFile={'personas'}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditPersonModal
				dataPerson={dataPerson}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<ImportPersonModal
				dataPerson={dataPerson}
				isEdit={isEdit}
				isOpen={modalImport}
				handleToggleModalImport={handleToggleModalImport}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<DeletePersonModal
				dataPerson={dataPerson}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default PersonList;
